export default "__VITE_ASSET__CLcmTMq3__"